module.exports = __webpack_public_path__ + "media/43.0a2c0b5e.wav";